import { html } from 'lit';
const TextBackgroundDuotone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill="#FCE5E6" fill-rule="evenodd" d="M3.15 5.5A2.35 2.35 0 0 1 5.5 3.15h13a2.35 2.35 0 0 1 2.35 2.35v13a2.35 2.35 0 0 1-2.35 2.35h-13a2.35 2.35 0 0 1-2.35-2.35z" clip-rule="evenodd"/><path fill="#000" fill-opacity=".1" fill-rule="evenodd" d="M3.15 5.5A2.35 2.35 0 0 1 5.5 3.15h13a2.35 2.35 0 0 1 2.35 2.35v13a2.35 2.35 0 0 1-2.35 2.35h-13a2.35 2.35 0 0 1-2.35-2.35zM5.5 3.85A1.65 1.65 0 0 0 3.85 5.5v13c0 .911.739 1.65 1.65 1.65h13a1.65 1.65 0 0 0 1.65-1.65v-13a1.65 1.65 0 0 0-1.65-1.65z" clip-rule="evenodd"/><path fill="#141414" fill-rule="evenodd" d="M10.622 7.505a1.471 1.471 0 0 1 2.756 0l3.324 8.865a.75.75 0 0 1-1.404.527l-.94-2.505H9.642l-.94 2.505a.75.75 0 1 1-1.404-.527zm-.418 5.387h3.592L12 8.102z" clip-rule="evenodd"/>
  </svg>
`;
export default TextBackgroundDuotone;
